import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { rootActions } from "../../actions/rootActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { hocPhanMienApi } from "../../../api/diem/hoc-phan-mien/hocPhanMienApi";
import { eHocPhanMienActionIds, IHocPhanMienActionTypes } from "../../action-types/hoc-phan-mien/hocPhanMienActions";
import { hoSoSinhVienApi } from "../../../api/category/hoSoSinhVienApi";
import { IHocPhanMienInsertsRequest } from "../../../model/request/diem/hoc-phan-mien/IHocPhanMienInsertsRequest";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";

export function* hocPhanMienSaga(): any {
    yield takeLatest(eHocPhanMienActionIds.LOAD_START, loadWorker);
    yield takeEvery(eHocPhanMienActionIds.LOAD_HO_SO_SINH_VIEN_START, loadHoSoSinhVienWorker);
    yield takeEvery(eHocPhanMienActionIds.INSERTS_START, insertsWorker);
    yield takeEvery(eHocPhanMienActionIds.DELETES_START, deletesWorker);
}   


function* loadWorker(action: IHocPhanMienActionTypes): any {
    var request = action.payload as number[];
    const response: IBaseResponse = yield call(hocPhanMienApi.SelectByLop, request);
    if (response.is_success) {
        yield put(rootActions.hocPhanMien.LOAD_SUCCESS(response.data));
    } else {
        yield put(rootActions.hocPhanMien.LOAD_ERROR(response.message ?? "Lỗi khi tải học phần miễn"));
    }
}

function* loadHoSoSinhVienWorker(action: IHocPhanMienActionTypes): any {
    var request = action.payload as number[];
    const response: IBaseResponse = yield call(hoSoSinhVienApi.SelectByLops, request);
    if (response.is_success) {
        yield put(rootActions.hocPhanMien.LOAD_HO_SO_SINH_VIEN_SUCCESS( toLowerCaseDeep(response.data)));
    } else {
        yield put(rootActions.hocPhanMien.LOAD_HO_SO_SINH_VIEN_ERROR(response.message ?? "Lỗi khi tải học phần miễn"));
    }
}

function* insertsWorker(action: IHocPhanMienActionTypes): any {
    debugger
    var request = action.payload as IHocPhanMienInsertsRequest;
    const response: IBaseResponse = yield call(hocPhanMienApi.Inserts, request);
    if (response.is_success) {
        yield put(rootActions.hocPhanMien.INSERTS_SUCCESS(response.data));
    } else {
        yield put(rootActions.hocPhanMien.INSERTS_ERROR(response.message ?? "Lỗi khi tải học phần miễn"));
    }
}

function* deletesWorker(action: IHocPhanMienActionTypes): any {
    var request = action.payload as number[];
    const response: IBaseResponse = yield call(hocPhanMienApi.Deletes, request);
    if (response.is_success) {
        yield put(rootActions.hocPhanMien.DELETES_SUCCESS(response.data));
    } else {
        yield put(rootActions.hocPhanMien.DELETES_ERROR(response.message ?? "Lỗi khi tải học phần miễn"));
    }
}